import type { ReactNode } from 'react';
import { Icon } from './Icon';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  onBack?: () => void;
  backLabel?: string;
  action?: ReactNode;
}

/** 56 px white header with a hairline beneath, one optional back button, one optional action. */
export function PageHeader({
  title,
  subtitle,
  onBack,
  backLabel = 'Back',
  action,
}: PageHeaderProps) {
  return (
    <header className="fw-header">
      {onBack && (
        <button type="button" onClick={onBack} aria-label={backLabel} className="fw-header__back">
          <Icon name="arrow-back" size={24} />
        </button>
      )}
      <span className={`fw-header__titles${onBack ? ' fw-header__titles--with-back' : ''}`}>
        <h1 className="fw-header__title">{title}</h1>
        {subtitle && <span className="fw-header__subtitle">{subtitle}</span>}
      </span>
      {action}
    </header>
  );
}
